import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BatchEffects } from 'app/shared/features/batch-selector/state/batch.effects';
import { BatchReducer } from 'app/shared/features/batch-selector/state/batch.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(BatchReducer), EffectsModule.forFeature([BatchEffects])],
})
export class BatchStateModule {}
